<template>
  <div class="breadcrumb">
    <ul>
      <li><i class="fa fa-dashboard" aria-hidden="true"></i> <router-link to="/">Dashboard</router-link></li>
      <template v-for="(link, i) in links" :key="i">
        <li><i class="fas fa-chevron-right"></i></li>
        <li><router-link :to="link.path" v-if="link.path">{{link.label}}</router-link><span v-else>{{link.label}}</span></li>
      </template>
    </ul>
  </div>
</template>

<style lang="scss">
.breadcrumb{
  height: 40px;
  border-bottom: 1px solid var(--color-container-border);
  background-color: var(--color-top-menu-bg);
  font-size: 0.9rem;
  margin-bottom: 0;

  a{
    color: var(--color-body-text);
    &:not(:hover) {
      text-decoration: none;
    }
  }

  ul{
    list-style-type: none;
    padding: 0;
    display: flex;
    margin: 0 15px;
    align-items: center;

    li{
      margin-right: 7px;

      i{
        font-size: 0.7rem;
      }
    }
  }
}
</style>

<script>
export default {
  props: ['links']
}
</script>